import { Space } from "antd";
import React from "react";
import { useModel } from "umi";
import AiAgent from "../AiAgent";
import AppDown from "./AppDown";
import Avatar from "./AvatarDropdown";
import styles from "./index.less";

export type SiderTheme = "light" | "dark";

const GlobalHeaderRight: React.FC<any> = () => {
  const { initialState } = useModel("@@initialState");

  if (!initialState || !initialState.settings) {
    return null;
  }

  const { navTheme, layout } = initialState.settings;
  let className = styles.right;

  if ((navTheme === "dark" && layout === "top") || layout === "mix") {
    className = `${styles.right}  ${styles.dark}`;
  }
  return (
    <>
      <AiAgent></AiAgent>

      <Space className={className}>
        {localStorage.getItem("menuType") == "shgl" && <AppDown></AppDown>}
        <Avatar />
      </Space>
    </>
  );
};
export default GlobalHeaderRight;
